import WarningPopup from './WarningPopup';

export default WarningPopup;
